import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { btnLocationEnum } from 'utils/segment';
import ProductCard from 'Scenes/Products/Product/Product';
import styles from './FeaturedProductCards.module.css';

const ProductCards = ({
  products,
  slideCount,
  viewSize,
  productCardWidth,
  productCardMargin,
  carouselHeightClassName,
  slideTotal,
}) => (
  <>
    {_.chunk(products, slideCount).map((group) => {
      return (
        <div
          className={classNames(styles.productCardContainer, {
            [styles.oneSlide]: slideTotal === 1,
          })}
        >
          {_.map(group, (item) => {
            return (
              <ProductCard
                viewSize={viewSize}
                positionLocation={btnLocationEnum.featuredCarousel}
                {...item}
                style={{
                  width: productCardWidth,
                  marginRight: slideCount === 1 ? 0 : productCardMargin,
                }}
                carouselHeightClassName={carouselHeightClassName}
                key={item.id}
              />
            );
          })}
        </div>
      );
    })}
  </>
);

ProductCards.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  slideCount: PropTypes.number.isRequired,
  viewSize: PropTypes.string.isRequired,
  productCardWidth: PropTypes.number.isRequired,
  productCardMargin: PropTypes.number.isRequired,
  carouselHeightClassName: PropTypes.string.isRequired,
  slideTotal: PropTypes.number.isRequired,
};

export default ProductCards;
